/* eslint-disable @angular-eslint/prefer-inject */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { TrucksService } from '../services/trucks.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-edit-truck',
  templateUrl: './edit-truck.component.html',
  styleUrls: ['./edit-truck.component.scss'],
  standalone: true,
  imports: [TegelModule, FormsModule, ReactiveFormsModule],
})
export class EditTruckComponent implements OnInit {
  formTruckEdit: FormGroup = new FormGroup({});

  constructor(
    private truckService: TrucksService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const truckId = Number.parseInt(this.route.snapshot.params['id']);
    const truckEdit = this.truckService.getById(truckId);

    this.formTruckEdit = new FormGroup({
      Id: new FormControl(truckEdit.Id),
      Name: new FormControl(truckEdit.Name),
      FuelType: new FormControl(truckEdit.FuelType),
      NumberOfAxis: new FormControl(truckEdit.NumberOfAxis),
    });
  }

  saveChanges(): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.truckService.setTruck(this.formTruckEdit.value);
    void this.router.navigate(['trucks']);
  }
}
